import { Box, Typography } from "@mui/material";

import styles from "./styles";

interface Props {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  chip?: React.ReactNode;
  iconSx?: object;
  titleSx?: object;
  sx?: object;
}

const CardHeader = ({
  icon,
  title,
  subtitle,
  chip,
  iconSx,
  titleSx,
  sx,
}: Props) => (
  <Box sx={{ ...styles.header, ...sx }}>
    <Box sx={styles.titleGroup}>
      <Box sx={{ ...styles.iconBox, ...iconSx }}>{icon}</Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ ...styles.title, ...titleSx }}>{title}</Typography>
        {subtitle && <Typography sx={styles.subtitle}>{subtitle}</Typography>}
      </Box>
    </Box>
    {chip && <Box sx={styles.chipSlot}>{chip}</Box>}
  </Box>
);

export default CardHeader;
